<template>
  <common-filter-form :filter="filterForm" :fields="allFields" :default-common-fields="defaultCommonFields" :default-more-fields="defaultMoreFields" config-key="testPlanFilterConfig" @change="handleFieldChange" @search="handleSearch" @reset="handleReset">
    <template slot="field" slot-scope="{ field, form, reset, labelCol, wrapperCol }">
      <test-plan-filter-form-item
        :form="form"
        :field="field"
        :options="{
          statusList: testPlanStatus,
          types: testPlanTypes
        }"
        :search-data="{
          story: {
            searching: storySearching,
            data: searchStoryData
          }
        }"
        :project-id="projectId"
        :reset="reset"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        @change="handleFieldChange"
        @search="handleFieldSearch"
      />
    </template>
  </common-filter-form>
</template>

<script>
import { storySearch } from '@/api/project/story';
import { testPlanTypes, testPlanStatus } from '@/utils/dictionary';

import CommonFilterForm from '@/components/CommonFilterForm';
import TestPlanFilterFormItem from './TestPlanFilterFormItem';

export default {
  name: 'TestPlanFilterForm',
  components: {
    CommonFilterForm,
    TestPlanFilterFormItem
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    projectId: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      filterForm: { ...this.value },
      testPlanTypes,
      testPlanStatus,
      storySearching: false,
      searchStoryData: [],
      // 所有可用的筛选项配置
      allFields: [
        { key: 'name', label: '计划名称', span: 6 },
        { key: 'status', label: '状态', span: 6 },
        { key: 'type', label: '类型', span: 6 },
        { key: 'handlers', label: '测试负责人', span: 6 },
        { key: 'creator', label: '创建人', span: 6 },
        { key: 'requirement', label: '关联需求', span: 6 },
        { key: 'dateRange', label: '时间筛选', span: 12, labelSpan: 3, wrapperSpan: 18 }
      ],
      // 默认常用筛选字段
      defaultCommonFields: ['name', 'status', 'type'],
      // 默认更多筛选字段
      defaultMoreFields: ['handlers', 'creator', 'requirement', 'dateRange']
    };
  },
  watch: {
    value: {
      handler(newVal) {
        if (newVal) {
          this.filterForm = { ...newVal };
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    handleFieldChange({ key, value }) {
      this.$set(this.filterForm, key, value);
      this.handleSearch();
    },

    handleSearch() {
      this.$emit('change', this.filterForm);
      this.$emit('update:value', this.filterForm);
    },

    handleReset() {
      // 定义默认的筛选表单值
      const defaultForm = {
        time_field: 'start_time',
        start_time: null,
        end_time: null
      };
      // 更新表单数据
      this.filterForm = { ...defaultForm };
      this.$emit('reset', this.filterForm);
    },

    handleFieldSearch({ key, value }) {
      if (key === 'story') {
        this.searchStory(value);
      }
    },

    // 搜索需求
    searchStory(value) {
      this.storySearching = true;
      storySearch({ project_id: this.projectId, value, page_size: 20 }).then(res => {
        this.searchStoryData = res.data.items;
        this.storySearching = false;
      });
    }
  }
};
</script>

<style lang="less" scoped>
.test-plan-filter-form {
  :deep(.ant-form-item) {
    margin-bottom: 0px;

    .ant-form-item-label {
      text-align: right;
      color: #495057;
      padding-right: 8px;
    }
  }
}
</style>
